import React, { PureComponent } from 'react'
import {
  func, shape, bool, string,
} from 'prop-types'
import Form, { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Button from '@active/react-ui/Button'
import Identity from '@active/react-utils/components/Identity'
import CountryDropdown from '../CountryDropdown'
import I18nMessage from '../I18nMessage'
import CommonError from '../CommonError'
import { emptyValidatorBuilder } from '../../../shared/validator'
import { noop } from '../../../shared/utils/commonUtils'

import './CountryContent.scss'

class CountryContent extends PureComponent {
  static propTypes = {
    handleChangeCountry: func.isRequired,
    handleCountryContentSubmit: func.isRequired,
    initResetHandler: func,
    fields: shape({ countryCode: string }),
    showError: bool,
    messageType: string,
    message: string,
    Body: func,
    Footer: func,
  }

  static defaultProps = {
    initResetHandler: noop,
    fields: { countryCode: '' },
    showError: false,
    messageType: null,
    message: null,
    Body: Identity,
    Footer: Identity,
  }

  constructor(props) {
    super(props)

    this.state = {
      fields: props.fields,
    }
  }

  componentDidMount() {
    const { initResetHandler } = this.props
    initResetHandler(this.resetCountry)
  }

  resetCountry = () => {
    this.formRef.handleReset()
  }

  submitForm = () => {
    this.formRef.submitForm()
  }

  render() {
    const {
      showError, messageType, message, handleChangeCountry, handleCountryContentSubmit, Body, Footer,
    } = this.props

    const { fields } = this.state
    return (
      <Identity>
        <Body>
          <div className="passport-content country-content">
            <Form initialValues={fields} onSubmit={handleCountryContentSubmit}>
              {showError && <CommonError showError={showError} msgType={messageType} errMsg={message} />}
              <div className="passport-ui-app__subTitle passport__pb5">
                <I18nMessage id="passport.waiver.selectCountry.notice" />
              </div>
              <FormGroup required withoutLayout>
                <FormLabel id="CountryDropdownLabel" htmlFor="countryCode">
                  <I18nMessage id="passport.countryConsents.countryRegion" />
                </FormLabel>
                <FormField
                  aria-required
                  aria-labelledby="CountryDropdownLabel"
                  className="passport__mb30"
                  name="countryCode"
                  as={CountryDropdown}
                  onChange={handleChangeCountry}
                  validate={emptyValidatorBuilder('passport.error.validation.countryPrompt')}
                  maxHeight="258px"
                  requiredError="passport.error.validation.countryPrompt"
                />
              </FormGroup>
              <FormConsumer>
                {({ form }) => {
                  this.formRef = form
                  return null
                }}
              </FormConsumer>
            </Form>
          </div>
        </Body>
        <Footer>
          <div className="passport-content-footer">
            <Button type="super" onClick={this.submitForm}>
              <I18nMessage id="passport.common.btn.next" />
            </Button>
          </div>
        </Footer>
      </Identity>
    )
  }
}

export default CountryContent
